import Router from 'vue-router'
import routes from './routes'

function beforeEach(to, from, next) {
  const app = this.app
  const service = app.$service || {}
  const state = service.state || {}
  document.title = to.meta.title || '广告投放平台'
  if (state.token) {
    next(to.name !== 'login' || to.name !== 'forgetPassword' || to.name !== 'register' || to.name !== 'changelog'
      ? undefined
      : { name: '/' }
    )
  } else {
    next(to.name === 'login' || to.name === 'forgetPassword' || to.name === 'register' || to.name === 'changelog'
      ? undefined
      : { name: 'login', query: { redirect: to.fullPath } }
    )
  }
}

function afterEach(to) {
  const app = this.app
  const breadcrumb = to.matched.slice(1).map(({ name, meta }) => {
    return {
      name: meta.title,
      to: name
        ? { name }
        : undefined
    }
  })
  app.$nextTick(() => {
    app.$bus.$emit('breadcrumb-change', breadcrumb)
  })
}

const router = new Router({
  routes
})
router.beforeEach(beforeEach.bind(router))
router.afterEach(afterEach.bind(router))

export default router
